export default __webpack_public_path__ + "static/media/1_0018.fd46f560.webp";